'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _productLabelPreview = require('./product-label-preview.component');

var _productLabelPreview2 = _interopRequireDefault(_productLabelPreview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('common.components.productLabelPreview', []).component('productLabelPreview', _productLabelPreview2.default).name;


// WEBPACK FOOTER //
// ./components/app/products/product-label-preview/product-label-preview.module.js